import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Table } from '@tmapy/style-guide';

import type { PriceBandResponse } from '../../openapi/types/PriceBand';
import { getPriceBandRange, isPriceBandFree } from '../utils';

import { priceListMessages as msg } from './priceListMessages';

type PriceBandsTableProps = {
  /**
   * U typů bez pásem chodí null, u datové položky, které je v administraci
   * ještě nikdo nevyplnil, prázdné pole — v obou případech patří prázdný stav.
   */
  bands: PriceBandResponse[] | null;
  /** Prázdné, dokud sazbu ve formuláři někdo nevyplní — pak se poznámka o DPH vynechá. */
  vatRate?: string | null;
  /** Pásma nepatří téhle položce, ale zvolenému typu — je potřeba to říct nahlas. */
  isReference?: boolean;
};

export const PriceBandsTable: React.FC<PriceBandsTableProps> = ({
  bands,
  vatRate,
  isReference,
}) => (
  <div className='sg-u-vs-1'>
    {bands?.length ? (
      <>
        <div className='sg-a-mx--2'>
          <Table>
            <thead>
              <tr>
                <th>
                  <FormattedMessage {...msg.bandsRangeColumn} />
                </th>
                <th className='sg-a-ta-r'>
                  <FormattedMessage {...msg.bandsPriceColumn} />
                </th>
              </tr>
            </thead>
            <tbody>
              {bands.map((band) => {
                const range = getPriceBandRange(band);

                return (
                  <tr key={`${band.from_ha}-${band.to_ha ?? ''}`}>
                    <td>
                      <FormattedMessage {...range.descriptor} values={range.values} />
                    </td>
                    <td className='sg-a-ta-r sg-a-ws-nw sg-a-fvn-tn'>
                      {isPriceBandFree(band) ? (
                        <FormattedMessage {...msg.bandsPriceFree} />
                      ) : (
                        <FormattedMessage
                          {...msg.bandsPriceCzk}
                          values={{ price: Number(band.price) }}
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        {isReference && (
          <p className='sg-u-type-sml sg-u-c-body-darkest'>
            <FormattedMessage {...msg.bandsReferenceNote} />
          </p>
        )}
        {vatRate && (
          <p className='sg-u-type-sml sg-u-c-body-darkest'>
            <FormattedMessage {...msg.bandsNetNote} values={{ vatRate: Number(vatRate) }} />
          </p>
        )}
      </>
    ) : (
      <p className='sg-u-c-body-darkest'>
        <FormattedMessage {...msg.bandsEmpty} />
      </p>
    )}
  </div>
);
